import React, { useEffect } from 'react';
import styled from 'styled-components';
import { colors } from '../../utils/theme';
import sonicFlowersImage from '../../images/Experiments/SonicFlowers.png';

const TestContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const HoverContainer = styled.div`
  position: relative;
  display: inline-block;
  /* When the container is hovered, show the background title and subtitle */
  &:hover .project-title-bg {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.2);
  }
  &:hover .project-subtitle {
    opacity: 1;
  }
`;

const ProjectBox = styled.div`
  width: 600px;
  height: 400px;
  background: url(${sonicFlowersImage}) center/cover no-repeat;
  backdrop-filter: blur(10px);
  padding: 2rem;
  margin: 2rem;
  position: relative;
  transition: transform 0.2s ease-out, mask-size 0.5s ease-in-out;
  

  /* The mask uses an inline SVG.
     The polygon points cut larger triangles from the top‑left and bottom‑right */
  mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 400'><polygon fill='white' points='80,0 600,0 600,320 520,400 0,400 0,80'/></svg>");
  mask-size: 130%;
  mask-repeat: no-repeat;
  mask-position: center;

  -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 400'><polygon fill='white' points='80,0 600,0 600,320 520,400 0,400 0,80'/></svg>");
  -webkit-mask-size: 130%;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;

  &:hover {
    mask-size: 68%;
    -webkit-mask-size: 80%;
  }

  @media (max-width: 768px) {
    width: 90%;
    height: 300px;
  }
`;

const ProjectTitleBg = styled.h1`
  position: absolute;
  top: 50% + 60px;
  left: 50%;
  /* Start centered behind the box */
  transform: translate(-50%, -50%) scale(1);
  font-size: 6rem;
  color: ${colors.titleColor};
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.5s ease, transform 0.5s ease;
  z-index: -1;
  width: 100%;
  text-align: center;
  white-space: nowrap;
  font-family: "moret-variable", serif;
`;

const ProjectSubtitle = styled.p`
  position: absolute;
  top: calc(100% - 70px);
  left: 50%;
  /* Start centered horizontally below the box */
  transform: translateX(-50%);
  font-size: 1.5rem;
  color: ${colors.subtitleColor};
  opacity: 0;
  transition: opacity 0.5s ease, transform 0.2s ease-out;
  white-space: nowrap;
  font-family: "maitree", serif;
`;

const ProjectAnimationTest = () => {
  useEffect(() => {
    const container = document.querySelector('.hover-container');
    const box = container.querySelector('.project-box');
    const subtitle = container.querySelector('.project-subtitle');

    const handleMouseMove = (e) => {
      // Use the container's bounding box for calculations.
      const rect = container.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      // Normalize the distance from center (-1 to 1)
      const distanceX = (e.clientX - centerX) / (rect.width / 2);
      const distanceY = (e.clientY - centerY) / (rect.height / 2);
      // Move up to 50px in any direction
      const moveX = distanceX * 50;
      const moveY = distanceY * 50;
      // Move the box with the mouse
      box.style.transform = `translate(${moveX}px, ${moveY}px)`;
      // Adjust the subtitle while preserving its centered start position
      subtitle.style.transform = `translate(calc(-50% + ${moveX}px), ${moveY}px)`;
    };

    const handleMouseLeave = () => {
      box.style.transform = 'translate(0, 0)';
      subtitle.style.transform = 'translate(-50%, 0)';
    };

    container.addEventListener('mousemove', handleMouseMove);
    container.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      container.removeEventListener('mousemove', handleMouseMove);
      container.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  return (
    <TestContainer>
      <h1 style={{ color: 'white', marginBottom: '2rem' }}>Project Animation Test Page</h1>
      <HoverContainer className="hover-container">
        <ProjectTitleBg className="project-title-bg">Test Project</ProjectTitleBg>
        <ProjectBox className="project-box" />
        <ProjectSubtitle className="project-subtitle">
          Hover over the card to see the effects.
        </ProjectSubtitle>
      </HoverContainer>
    </TestContainer>
  );
};

export default ProjectAnimationTest;
